import { shuffledArray } from '../helpers/shuffleArray';
import gameData from '../API/gameData';

const initState = {
  gameData,
  loading: true,
  showWarning: false,
  blocksMounted: false,
  correctBlockOrder: new Array(12).fill().map((val, index) => index),
  shuffledBlockOrder: shuffledArray(12),
  viewing: 'selector',
  game: {
    moveCount: 0,
    roundWin: false,
    started: false,
    restarted: false,
    timeOut: false,
  },
  settings: {
    shuffle: true,
    countDown: false,
    countUp: true,
    numOfBlocks: 12,
  },
  nav: {
    open: false,
  },
  saved: {
    level: 1,
    gameLevel: 0,
    unlockedLevels: 0,
    best: new Array(gameData.length)
      .fill()
      .map(() => ({ timeTaken: 99999, moveCount: 99999, starCount: 0 })),
  },
};

export default initState;



// WEBPACK FOOTER //
// ./src/state-store/initState.js